"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTableData = void 0;
var apps_shared_1 = require("@l2p/apps-shared");
var profile_api_1 = require("@l2p/profile-api");
var ui_components_1 = require("@l2p/ui-components");
var date_fns_1 = require("date-fns");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var useGetStatus_1 = require("./useGetStatus");
var useTableData = function (data) {
    var t = (0, next_intl_1.useTranslations)('translation');
    var getStatus = (0, useGetStatus_1.useGetStatus)();
    return (0, react_1.useMemo)(function () {
        var table = {
            columns: [
                {
                    field: 'title',
                    label: t('title'),
                },
                {
                    field: 'content',
                    label: t('content'),
                },
                {
                    field: 'added',
                    label: t('added'),
                },
                {
                    field: 'status',
                    label: t('status'),
                },
            ],
            rows: [],
            fullInfoRows: [],
        };
        table.rows = data.map(function (item) {
            var startAmount = item.startAmount, createdAt = item.createdAt, status = item.status, startBalance = item.startBalance, bonus = item.bonus, type = item.type, currency = item.currency;
            return {
                title: (bonus === null || bonus === void 0 ? void 0 : bonus.title) || '',
                added: (0, date_fns_1.format)(new Date(createdAt), 'yyyy-LL-dd, HH:mm'),
                content: type === apps_shared_1.BonusTypes.BONUSES
                    ? "".concat((0, apps_shared_1.getCurrencySymbol)(currency), " ").concat(Number(startBalance).toFixed(2))
                    : "".concat(startAmount, " ").concat(t('freespins')),
                status: (react_1.default.createElement(ui_components_1.StatusText, { status: getStatus(status), textAlign: "flex-start" }, t(status))),
            };
        });
        table.fullInfoRows = data.map(function (item) {
            var expireDate = item.expireDate, status = item.status, startBalance = item.startBalance, balance = item.balance, wageringBalance = item.wageringBalance, startWageringBalance = item.startWageringBalance, type = item.type, currency = item.currency, amount = item.amount;
            var result = [];
            result.push({
                property: 'completed',
                value: (0, date_fns_1.format)(new Date(expireDate), 'yyyy-LL-dd, HH:mm'),
            });
            if (type === apps_shared_1.BonusTypes.FREESPINS) {
                var reward = balance;
                if (status !== profile_api_1.FreeRoundStatus.Finished)
                    reward = 0;
                result.push({
                    property: 'freespinWinnings',
                    value: "".concat((0, apps_shared_1.getCurrencySymbol)(currency), " ").concat(Number(reward).toFixed(2)),
                });
            }
            if (type === apps_shared_1.BonusTypes.BONUSES)
                result.push({
                    property: 'amountWagered',
                    value: (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("span", null, "".concat((0, apps_shared_1.getCurrencySymbol)(currency), " ").concat(Number(Number(startWageringBalance || 0) -
                            Number(wageringBalance || 0)).toFixed(2))), " / ".concat((0, apps_shared_1.getCurrencySymbol)(currency), " ").concat(Number(startWageringBalance).toFixed(2)))),
                });
            if (type === apps_shared_1.BonusTypes.BONUSES) {
                result.push({
                    property: 'reward',
                    value: type === apps_shared_1.BonusTypes.BONUSES
                        ? "".concat((0, apps_shared_1.getCurrencySymbol)(currency), " ").concat(Number(startBalance).toFixed(2))
                        : "".concat(amount, " ").concat(t('freespins')),
                });
            }
            return result;
        });
        return table;
    }, [getStatus, data, t]);
};
exports.useTableData = useTableData;
